module.exports = __webpack_public_path__ + "img/language.0aff1bc0.svg";